module.exports = __webpack_public_path__ + "static/media/img2.0f2511bb.jpg";